import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fire a /track event on every route change.
 * Skipped on /admin and the OAuth callback (#session_id=...).
 */
export default function VisitTracker() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const path = location.pathname || "/";
    if (path.startsWith("/admin")) return;
    if (window.location.hash?.includes("session_id=")) return;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Fire and forget — never block render or surface errors to UI
    api
      .post("/track", {
        path,
        referrer: document.referrer || "",
        ua: navigator.userAgent || "",
        screen: `${window.innerWidth}x${window.innerHeight}`,
        lang: navigator.language || "",
      })
      .catch(() => {});
  }, [location.pathname]);

  return null;
}
